import React from 'react';
import BaseGatewaysBehindNat from '../../AbstractObjects/GatewayPlan/InnerPages/BaseGatewaysBehindNat';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';

const pageSchema = GatewayGetSchema.pages.gatewaysBehindNAT;
const pageId = pageSchema.pageId;

function PlanGatewaysBehindNat({
    planObject,
    setPlanData
}) {

    let pageData = planObject[pageId];

    return (
        <BaseGatewaysBehindNat
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanGatewaysBehindNat;